import MyCancellationStatusChip from './MyCancellationStatusChip';

const MyDeniedRequestsChip = () => <MyCancellationStatusChip variant="denied" />;

export default MyDeniedRequestsChip;
